import api from '../../../services/api';

export interface CustomerProductPrice {
  id: string;
  customerId: string;
  productVariantId: string;
  fixedPrice: number;
  currency: string;
  variantSku?: string | null;
  variantName?: string | null;
  isDefault?: boolean;
  productId?: string | null;
  productCode?: string | null;
  productEan?: string | null;
  productName?: string | null;
  width?: number | null;
  height?: number | null;
  length?: number | null;
  thickness?: number | null;
  productCategoryName?: string | null;
  productCategoryColor?: string | null;
  productCategoryDimensionDisplayProfile?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface CustomerProductPricePayload {
  productVariantId: string;
  fixedPrice: number;
  currency: string;
}

export async function fetchCustomerProductPrices(
  customerId: string
): Promise<CustomerProductPrice[]> {
  const response = await api.get(`/customers/${customerId}/product-prices`);
  return response.data;
}

export async function saveCustomerProductPrice(
  customerId: string,
  payload: CustomerProductPricePayload
): Promise<CustomerProductPrice> {
  const response = await api.post(`/customers/${customerId}/product-prices`, payload);
  return response.data;
}

export async function updateCustomerProductPrice(
  customerId: string,
  priceId: string,
  payload: Pick<CustomerProductPricePayload, 'fixedPrice' | 'currency'>
): Promise<CustomerProductPrice> {
  const response = await api.put(`/customers/${customerId}/product-prices/${priceId}`, payload);
  return response.data;
}

export async function deleteCustomerProductPrice(
  customerId: string,
  priceId: string
): Promise<void> {
  await api.delete(`/customers/${customerId}/product-prices/${priceId}`);
}
